import Store from "@ember-data/store";
export function initialize(owner) {
  const store = owner.lookup("service:store");
  const nephro = store.peekRecord("therapeutical-area", "nephro");
  const pneumo = store.peekRecord("therapeutical-area", "pneumo");
  const cardio = store.peekRecord("therapeutical-area", "cardio");
  const hepato = store.peekRecord("therapeutical-area", "hepato");
  const onco = store.peekRecord("therapeutical-area", "onco");
  const rhumato = store.peekRecord("therapeutical-area", "rhumato");
  const diabete = store.peekRecord("therapeutical-area", "diabeto");
  const data = {
    "77348-1": [nephro, pneumo, cardio, hepato],
    "53828-0": [nephro, pneumo, cardio, hepato],
    "72671-1": [nephro, pneumo, cardio, hepato],
    "72676-0": [nephro, pneumo, cardio, hepato],
    "14682-9": [nephro, pneumo, cardio, hepato],
    "777-3": [nephro, pneumo, cardio, hepato, onco],
    "26499-4": [nephro, pneumo, cardio, hepato],
    "1988-5": [nephro, pneumo, cardio, hepato, rhumato],
    "6690-2": [onco],
    "6875-9": [onco],
    "13457-7": [onco, diabete],
    "30341-2": [rhumato],
    "18184-2": [rhumato],
    "718-7": [rhumato],
    "4548-4": [diabete],
    "62238-1": [diabete],
    "9318-7": [diabete]
  };
  Object.entries(data).forEach(([id, therapeuticalAreas]) => {
    store.createRecord("priority-bio-exam", {
      id,
      therapeuticalAreas
    });
  });
}
export default {
  after: "therapeutical-areas",
  initialize
};